<template>
  <a-space>
    <a-select
      v-model:value="value"
      @search="handleSearch"
      @focus="handleSearch"
      @change="handleChange"
      :disabled="useDisable"
      showSearch
      :options="options"
      :placeholder="placeholder"
      style="width: 225px; margin-bottom: 5px"
      :dropdownMatchSelectWidth="false"
      allowClear
    >
    </a-select>

    <a-button
      size="small"
      @click="handelStatusChange"
      :type="useDisable ? '' : 'primary'"
      >{{ useDisable ? "修改" : "保存" }}
      <template #icon>
        <FormOutlined v-if="useDisable" />
        <SaveOutlined v-else />
      </template>
    </a-button>
  </a-space>
</template>

<script>
import { debounce, Toast } from "@/utils";
import { getInventoryInfo } from "@/request/view/productionInstruction";
import { computed, defineComponent, reactive, ref, watch } from "vue";
import { FormOutlined, SaveOutlined } from "@ant-design/icons-vue";
import { subordinateProcessAssociation } from "@/request/view/dailyQualityInspection";
import { updatePQC } from "@/request/view/dailyQualityInspection";
import {
  getProcessName,
  checkTypeInProject,
} from "@/views/productDaily/serve/option";

export default defineComponent({
  components: { FormOutlined, SaveOutlined },
  props: {
    type: String,
    produceOrTpc: String,
    modelSpecifications: String,
    superior: Object,
  },
  setup(props, context) {
    const value = ref(null);
    const useDisable = ref(false);
    const options = reactive([]);

    const cacheSubOrdinate = reactive({
      id: null,
      productionTaskId: null,
    });

    const placeholder = computed(() => {
      if (props.type) {
        const type = getProcessName(props.type);
        return `请选择${type}工序`;
      }
      return "请选择工序";
    });

    // 处理总装调试请求数据
    const handleUpdatAassembleDebugQuery = (query) => {
      const project = checkTypeInProject(query.modelSpecifications);
      if (!project) return;
      const model = project.children.find((f) => f.label === project.value);
      if (!model) return;
      query.modelSpecifications = model.value;
    };

    const getInventoryInfoByProcess = () => {
      options.length = 0;

      const query = {
        type: props.type,
        produceOrTpc: props.produceOrTpc,
        modelSpecifications: props.modelSpecifications,
      };

      if (props.type === "assembleDebug") {
        handleUpdatAassembleDebugQuery(query);
      }

      getInventoryInfo(query).then((res) => {
        if (
          res.code === 200 &&
          res.message === "成功" &&
          res.data &&
          Object.keys(res.data).length > 0
        ) {
          Object.keys(res.data).forEach((key) => {
            res.data[key].forEach((item) => {
              options.push({
                label: `${key}: ${item.outputSnNumber || item.snNumber}`,
                value: item.id,
                productionTaskId: item.productionTaskId,
              });
            });
          });
        }
      });
    };

    const handleSearch = debounce((val) => {
      getInventoryInfoByProcess();
    }, 50);

    const findValue = () => {
      if (props.superior && props.superior.children && props.type) {
        const list = props.superior.children;
        const subOrdinate = list.find((f) => f.type === props.type);

        return subOrdinate;
      }
      return null;
    };

    const init = () => {
      const subOrdinate = findValue();
      if (subOrdinate) {
        value.value = subOrdinate.id;
        cacheSubOrdinate.id = subOrdinate.id;
        cacheSubOrdinate.productionTaskId = subOrdinate.productionTaskId;
        options.push({
          label: subOrdinate.outputSnNumber || subOrdinate.snNumber,
          value: subOrdinate.id,
          productionTaskId: subOrdinate.productionTaskId,
        });
        useDisable.value = true;
      }
    };

    init();

    // 取消关联
    const disassociation = () => {
      return new Promise((resolve, reject) => {
        useDisable.value = true;
        updatePQC({
          id: cacheSubOrdinate.id,
          subordinateProcess: null,
          productionTaskId: cacheSubOrdinate.productionTaskId,
        })
          .then((res) => {
            useDisable.value = false;
            if (res.code === 200 && res.message === "成功") {
              cacheSubOrdinate.id = null;
              cacheSubOrdinate.productionTaskId = null;
              resolve();
            }
            let type = res.code === 200 ? "success" : "warning";
            Toast(type, "取消关联", 3);
          })
          .catch((err) => {
            useDisable.value = false;
            reject();
          });
      });
    };

    // 关联
    const association = () => {
      return new Promise((resolve, reject) => {
        if (props.superior && props.superior.id && value.value) {
          useDisable.value = true;
          subordinateProcessAssociation(props.superior.id, [value.value])
            .then((res) => {
              useDisable.value = false;
              let type = res.code === 200 ? "success" : "warning";
              Toast(type, res.message, 3);
              resolve();
            })
            .catch((err) => {
              useDisable.value = false;
              reject(err);
            });
        }
      });
    };

    const handleChange = (e) => {
      // 点击X图标取消关联
      if (cacheSubOrdinate.id !== null && e === undefined) {
        disassociation();
        return;
      }
      value.value = e;
    };

    const handelStatusChange = () => {
      if (!value.value && useDisable.value === false)
        return Toast("warning", "请选择工序", 3);
      useDisable.value = !useDisable.value;

      if (useDisable.value) {
        const item = options.find((f) => f.value === value.value);

        console.log(item, cacheSubOrdinate, "cache");
        // 缓存有值判断是否一致
        if (item.value === cacheSubOrdinate.id) return;

        if (
          item.value !== cacheSubOrdinate.id &&
          cacheSubOrdinate.id !== null
        ) {
          disassociation().then(() => {
            association().then((res) => {
              cacheSubOrdinate.id = item.value;
              cacheSubOrdinate.productionTaskId = item.productionTaskId;
              useDisable.value = true;
            });
          });
          return;
        }
        // 缓存无值直接绑定
        if (cacheSubOrdinate.id === null) {
          association().then((res) => {
            cacheSubOrdinate.id = item.value;
            cacheSubOrdinate.productionTaskId = item.productionTaskId;
            useDisable.value = true;
          });
        }
      }
    };

    return {
      value,
      options,
      getProcessName,
      placeholder,
      handleChange,
      handleSearch,
      useDisable,
      handelStatusChange,
      getInventoryInfoByProcess,
    };
  },
});
</script>

<style lang="less" scoped>
:deep(.ant-select-single) {
  margin-bottom: 0 !important;
}
</style>
